import React from 'react';
import { motion } from 'framer-motion';

const PrivacyChronoArena = () => {
  return (
    <div className="pt-24 pb-20 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 legal-content">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        <span className="text-accent-orange font-semibold tracking-wider text-sm uppercase mb-2 block">App Specific Policy</span>
        <h1>Chrono Arena: Myth Wars Privacy Policy</h1>
        <p className="text-sm border-l-2 border-accent-orange pl-4 mb-8">
          Last Updated: June 2026
        </p>

        <p>
          This document outlines the specific privacy practices for <strong>Chrono Arena: Myth Wars</strong>. 
          It serves as an addendum to the general MediaVerse Labs Privacy Policy.
        </p>

        <h2>1. No Data Collection</h2>
        <p>
          Chrono Arena: Myth Wars does not collect, transmit, or store any personal information. 
          We do not track your play time, achievements, or gameplay choices on our servers.
        </p>

        <h2>2. Local Save Data</h2>
        <p>
          All progress, save files, and settings are stored exclusively on your local device. 
          The game uses the standard Windows AppData directory for save storage. 
          No cloud saves are managed by MediaVerse Labs.
        </p>

        <h2>3. Third-Party Platforms</h2>
        <p>
          The game is distributed via the Microsoft Store. While the game itself does not 
          track you, the Microsoft Store platform may collect basic telemetry related to 
          installation and app crashes as per their own privacy policy.
        </p>

        <h2>4. Zero Telemetry</h2>
        <p>
          Chrono Arena: Myth Wars contains no telemetry code. 
          We do not know which mythic age you're conquering or how many god-beasts you've slain. 
          Your legend remains yours alone.
        </p>

        <h2>5. Contact</h2>
        <p>
          For privacy inquiries: <a href="mailto:hello@mediaverselabs.com">hello@mediaverselabs.com</a>
        </p>
      </motion.div>
    </div>
  );
};

export default PrivacyChronoArena;
